<template>
  <div class="app-wrapper">
    <nav-bar />
    <div class="main-container" ref="mainContainer">
      <app-main v-if="isAlive" />
      <toolbar />
    </div>
  </div>
</template>

<script>
import { NavBar, AppMain, Toolbar } from "./components";
export default {
  name: "Layout",
  components: {
    NavBar,
    AppMain,
    Toolbar,
  },
  data () {
    return {
      isAlive:true
    }
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  methods: {
    toTop() {
      var el = this.$refs.mainContainer;
      var timer = setInterval(function () {
        let osTop = el.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        el.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 15);
    },
    reload (){
       this.isAlive = false;
       this.$nextTick(function(){
          this.isAlive = true
       })
    }
  },
};
</script>
